"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'cost.preview.title': 'Szczegóły Kosztów Użycia',
    'cost.preview.back': 'Powrót do Raportów',
    'cost.preview.loading': 'Ładowanie szczegółów kosztów...',
    'cost.preview.error.load_failed': 'Nie udało się załadować szczegółów kosztów użycia',
    'cost.preview.not_found.title': 'Wpis Kosztów Nie Znaleziony',
    'cost.preview.not_found.description': 'Żądany wpis kosztów użycia nie został znaleziony lub nie masz uprawnień do jego wyświetlenia.',
    'cost.preview.section.token_usage': 'Użycie Tokenów',
    'cost.preview.section.cost_info': 'Informacje o Kosztach',
    'cost.preview.section.performance': 'Metryki Wydajności',
    'cost.preview.section.context_info': 'Informacje Kontekstowe',
    'cost.preview.reasoning_tokens': 'Tokeny Rozumowania',
    'cost.preview.cached_tokens': 'Tokeny Cache',
    'cost.preview.upstream_cost': 'Koszt Upstream',
    'cost.preview.cost_per_token': 'Koszt za 1M Tokenów',
    'cost.preview.cost_type': 'Typ Kosztu',
    'cost.preview.type.standard': 'Standardowy',
    'cost.preview.response_time': 'Całkowity Czas Odpowiedzi',
    'cost.preview.response_begin_time': 'Czas do Pierwszego Tokena',
    'cost.preview.efficiency': 'Efektywność Przetwarzania',
    'cost.preview.efficiency.excellent': 'Doskonała',
    'cost.preview.efficiency.good': 'Dobra',
    'cost.preview.efficiency.average': 'Średnia',
    'cost.preview.efficiency.slow': 'Wolna',
    'cost.preview.efficiency.unknown': 'Nieznana',
    'cost.preview.time.not_available': 'N/D',
    'cost.preview.no_tools': 'Nie używano narzędzi',
    'cost.preview.message_id': 'ID Wiadomości',
    'cost.preview.user.unknown': 'Nieznany Użytkownik',
    'cost.preview.avatar.none': 'Brak Awatara',
    'cost.preview.model.unknown': 'Nieznany Model',
    'cost.preview.view_details': 'Zobacz Szczegóły',
};
